module.exports = __webpack_public_path__ + "static/media/error-page-top-icon.e9a59f99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error-page-top-icon.svg
// module id = 232
// module chunks = 0